// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;You of low or high degree,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;both rich and poor together.<br> </p> </div></div>";
// Exports
module.exports = code;